import {mapValues, groupBy, omit} from 'external/lodash'
import update from 'external/immutability-helper'

export function associate(head, ...keys) {
  return (data) => keys.length > 0
    ? mapValues(groupBy(data, (item) => item[head]), associate(...keys))
    : data[0][head]
}

export function reduceByKey(key, omitKey) {
  return data => data.reduce((grouped, item) => ({...grouped, [item[key]]: omitKey ? omit(item, [key]) : item}), {})
}

export function accumulateByKey(key, omitKey) {
  return data => data.reduce((grouped, item) => update(grouped, {[item[key]]: {$autoArray: {$push: [(omitKey ? omit(item, [key]) : item)]}}}), {})
}

export function sleep(ms) {
  return new Promise(resolve => setTimeout(resolve, ms))
}